import React from 'react';
import { ContentCards } from '@hz-design-system/web-ui';

import FeedItem from './FeedItem';
import FeedItemListSkeleton from './FeedItemListSkeleton';

import { TFeedItem } from 'types/TFeeds';

type TFeedsItemsProps = {
  items: TFeedItem[];
  isLoading: boolean;
  shouldOpenInNewTab?: boolean;
};

const FeedItemList = ({ items, isLoading }: TFeedsItemsProps) => {
  return (
    <>
      {isLoading && <FeedItemListSkeleton />}
      {!isLoading && (
        <ContentCards kind="grid">
          {items.map((item, i) => (
            <FeedItem item={item} key={`${item.itemId}-${i}`} />
          ))}
        </ContentCards>
      )}
    </>
  );
};

export default FeedItemList;
